import { calcSalary } from './calcSalary';

export const calcTotalSalary = (orders, payment) => {
	const total = orders.reduce(
		(current, next) =>
			current +
			calcSalary(next.big_items_count, next.small_items_count, payment),
		0,
	);
	return Math.round(total * 100) / 100;
};
